// extracted by mini-css-extract-plugin
export var container = "_90-0";
export var error = "_90-9";
export var label = "_90-5";
export var light = "_90-6";
export var md = "_90-3";
export var sm = "_90-2";
export var thin = "_90-8";
export var thinBold = "_90-7";
export var vertical = "_90-4";
export var xs = "_90-1";